import { AGENT_TURN_STATUS_TYPES, TURN_INTERRUPTED_TEXT } from '@kentik/ui-shared/kaizen/constants';

export const TURN_END_TEXT = {
  [AGENT_TURN_STATUS_TYPES.CANCELLED]: 'Response stopped.',
  [AGENT_TURN_STATUS_TYPES.EXPIRED]: 'This request expired. Ask again to continue.'
};

export const isInterruptedTurn = (turn) => turn?.error_message === TURN_INTERRUPTED_TEXT;
